import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-abteilung';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsRolleAbteilungEffects {

    RolleAbteilung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_ABTEILUNG),
        mergeMap((x: ac.GetRolleAbteilungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleAbteilung(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetRolleAbteilungErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleAbteilungFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
